import { getImages } from '../../../Utils/FlavourUtils';

const styles = {
    primaryColor: `#009cb4`,
    secondaryColor: `#4e4ec0`,
    oozColor: `#808080`,

    polygon: {
        inZoneColor: `#000000`,
        inZoneOpacity: `0.2`,
        outOfZoneColor: `#000000`,
        outOfZoneOpacity: `0.2`,
        outlineStrokeColorInZone: `#009cb4`,
        outlineStrokeColorOutOfZone: `#d9d9d9`,
    },

    googleMapStyles: [
        {
            "elementType": "labels.text",
            "stylers": [{"saturation": -100}, {"lightness": 15}, {"visibility": "simplified"}]
        }, {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#e8e8e8"}]
        }, {
            "featureType": "administrative",
            "elementType": "labels.text",
            "stylers": [{"visibility": "simplified"}]
        }, {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [{"color": "#929292"}]
        }, {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#edf1f5"}, {"weight": 1.5}]
        }, {"featureType": "poi", "elementType": "geometry.fill", "stylers": [{"color": "#d6edc5"}]}, {
            "featureType": "poi",
            "elementType": "labels.text",
            "stylers": [{"lightness": 35}, {"visibility": "simplified"}]
        }, {"featureType": "poi.business", "stylers": [{"visibility": "off"}]}, {
            "featureType": "poi.park",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#b6e0c6"}]
        }, {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [{"visibility": "simplified"}]
        }, {"featureType": "road", "elementType": "geometry.fill", "stylers": [{"color": "#ffffff"}]}, {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [{"color": "#ffffff"}]
        }, {"featureType": "road.arterial", "stylers": [{"visibility": "simplified"}]}, {
            "featureType": "road.highway",
            "stylers": [{"visibility": "simplified"}]
        }, {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#e0e2ef"}]
        }, {
            "featureType": "road.highway",
            "elementType": "labels.text",
            "stylers": [{"visibility": "simplified"}]
        }, {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [{"color": "#8986b3"}]
        }, {"featureType": "road.local", "stylers": [{"visibility": "simplified"}]}, {
            "featureType": "transit",
            "stylers": [{"visibility": "simplified"}]
        }, {
            "featureType": "transit",
            "elementType": "labels.icon",
            "stylers": [{"saturation": -35}, {"lightness": 15}]
        }, {
            "featureType": "transit",
            "elementType": "labels.text",
            "stylers": [{"visibility": "simplified"}]
        }, {
            "featureType": "transit.station",
            "elementType": "labels.icon",
            "stylers": [{"saturation": -35}, {"lightness": 10}, {"visibility": "simplified"}]
        }, {"featureType": "water", "elementType": "geometry.fill", "stylers": [{"color": "#c0e0f6"}]}, {
            "featureType": "water",
            "elementType": "labels.text",
            "stylers": [{"color": "#6fa1c6"}, {"visibility": "simplified"}]
        }]
};

const constants = {
    "IOS_DOWNLOAD_LINK": `https://itunes.apple.com/app/id1200453687`,
    "ANDROID_DOWNLOAD_LINK": `https://play.google.com/store/apps/details?id=arriva.click&amp;amp;hl=en_GB`,
    "TERMS_OF_USE_LINK": `https://www.arrivabus.co.uk/arrivaclick/terms-and-conditions`,
    "POLICY_LINK": `https://www.arrivabus.co.uk/arrivaclick/privacy-policy`,
};

const strings = {
    "title": "ArrivaClick",
    "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    "months": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    "cancel_button_text": "Cancel Ride",
    "call_driver_text": "Contact Driver",
    "book_ride_label_text": "Book This Ride",
    "offer_timed_out_label_text": "Offer Timed Out. Request Another.",
    "choose_passenger_count_overlay_message_window_title_text": "Select no. of passengers",
    "choose_passenger_count_book_text": "Set no. of passengers",
    "send_feedback_overlay_message_window_title_text": "How was your last ride\nwith {driverName}?",
    "send_feedback_send_text": "Done",
    "pickup_marker_driver_arrived": "Your driver has arrived",
    "passenger_count_verbal_names": [
        "Just me",
        "Two of us",
        "We're three",
        "Party of four"
    ],
    "feedback_date_format": "{dayName}, {dateNumber} {monthName} {yearNumber}",
    "call_dispatch_text": "Delta",

    "enjoy_your_ride_title": "Enjoying your ride?",
    "enjoy_your_ride_content": "Enjoyed your ride?\nDownload the app here:",

    "thank_you_screen_title": "Thanks for riding with ArrivaClick",
    "thank_you_screen_content": "Enjoyed your ride?\nDownload the app here:",

    "bottom_proposal_box_title_text": "Your Ride Details",
    "bottom_proposal_box_plate_prefix": "Plate: ",
    "proposal_eta_less_than_minute": "Less Than a Minute",
    "proposal_eta_one_minute": "Pickup In 1 Minute",
    "proposal_eta_more_than_minute": "Pickup In {minuteValue} Minutes",
    "set_origin_button_text": "Set Pickup",
    "set_dest_button_text": "Set Dropoff",
    "set_ooz_button_text": "Out of Zone",

    "waiting_driver_approval_title": "Contacting nearby drivers...",
    "waiting_driver_approval_cancel_text": "Cancel",

    "origin_address_label": "Pickup:",
    "dest_address_label": "Dropoff:",

    "manual_stop_origin_selection_title": "Select pickup location:",
    "manual_stop_dest_selection_title": "Select dropoff location:",

    "welcome_page_title": "Welcome {riderName},\nRiding with ArrivaClick is easy:",
    "welcome_page_content": "Set your pick up and drop off.\nConfirm & Accept.\nEnjoy your ride!",
    "welcome_page_button_text": "Let's go",
    "welcome_page_disclaimer": "By pressing \"{acceptButton}\" you agree to ArrivaClick's\n{termsOfUse} and {policy}",

    "address_search_suggestions_title": "SUGGESTIONS",
    "address_search_origin_placeholder": "Pickup Address",
    "address_search_dest_placeholder": "Dropoff Address",

    "blocking_technical_issue_text": "We may experiencing a technical issue.\nPlease try again soon.",

    "alert_window_generic_error_title_text": "Oh no!",
    "alert_window_generic_accept_button_text": "OK",
    "alert_window_generic_cancel_button_text": "Cancel",
    "alert_message_cancel_ride_title_text": "Cancel the ride?",
    "alert_message_cancel_ride_confirm_text": "Yes",
    "alert_message_cancel_ride_cancel_text": "No",
    "alert_message_cancel_proposal_text": "Are you sure you want to cancel?",
    "alert_message_cancel_flex_proposal_title": "Cancel proposal",
    "alert_message_cancel_flex_proposal_text": "Are you sure you want to cancel the proposal?",
    "alert_message_call_driver_title_text": "Contact Driver?",
    "alert_message_call_driver_content_text": "Would you like to call your assigned driver?",
    "alert_message_call_driver_cancel_text": "Cancel",
    "alert_message_call_driver_call_text": "Call",
    "alert_message_call_driver_failure_content_text": "Seems like we could not connect you to your driver. Sorry about that.",
    "alert_message_ride_was_cancelled_title_text": "Your ride was cancelled",
    "alert_message_ride_was_cancelled_content_text": "It seems your ride was cancelled. We are sorry about that and hope to see you again!",
    "alert_message_no_show_title_text": "Oh no!",
    "alert_message_no_show_content_text": "Your driver reached the pickup point but could not find you. We are sorry about that and hope to see you again!",
    "alert_message_technical_issue_text": "We're sorry to report that we're currently experiencing a technical issue. We're on the case, and we should be up and running soon!",
    "alert_message_proposal_timed_out_title_text": "",
    "alert_message_proposal_timed_out_content_text": "This ride is no longer available. Request another ride?",
    "alert_message_proposal_timed_out_confirm_button_text": "Yes",
    "alert_message_proposal_timed_out_cancel_button_text": "No",
    // }
};

/* This line can't be a part of getImages because require.context can only accept a string literal for a path.
   See https://stackoverflow.com/questions/45458809/why-cant-i-determine-the-path-for-require-context-in-a-karma-shim-by-passing-a
 */
const context = require.context('./images', false);
const images = getImages(context);

export default { styles, constants, strings, images };








// WEBPACK FOOTER //
// ./src/Assets/flavours/arrivaClick/flavour.js